import { Outlet, Navigate } from 'react-router-dom';

import { AuthContext } from '../contexts/auth'
import { useContext } from 'react';


export default function PrivateRoutes(){
  const { signed } = useContext(AuthContext);
  console.log("PrivateRoutes");

  return (
    signed ? <Outlet/> : <Navigate to="/"/>
  )
}
